import { call, put, takeEvery, select } from "redux-saga/effects";
import { setWHCheckCampaignNames, WarehouseNamesLoader, cabinetLimitsLoader, setCabinetLimits, setCabinetLimitsTotal } from "./actions";
import { getWarehouseCheckCampaignNames, getWarehouseCabinetLimits, getWarehouseCabinetLimitsTotal } from "../../helpers/jwt_helper.js";
import { GET_WAREHOUSE_CHECK_CAMPAIGN_NAMES, GET_WAREHOUSE_CABINET_LIMITS, GET_WAREHOUSE_CABINET_LIMITS_TOTAL } from "./actionTypes";

import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetCabinetLimits({ payload: data }) {
  try {
    yield put(cabinetLimitsLoader());
    let response = yield call(getWarehouseCabinetLimits, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      date_gte: data.date_gte,
      date_lte: data.date_lte,
      ...(data?.cabinet_id && { cabinet_id: data?.cabinet_id })
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setCabinetLimits(response));
    yield put(cabinetLimitsLoader());
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
    yield put(cabinetLimitsLoader());
  }
}

function* onGetCabinetLimitsTotal({ payload: data }) {
  try {
    let response = yield call(getWarehouseCabinetLimitsTotal, {
      cabinet_id: data?.cabinet_id,
      date_gte: data.date_gte,
      date_lte: data.date_lte,
    });
    yield put(setCabinetLimitsTotal(response));
  } catch (error) {
    showErrorMessage(getErrorMessage(error));
  }
}

function* onGetWarehouseCheckCampaignNames({ payload }) {
  try {
    yield put(WarehouseNamesLoader());
    let results = yield call(getWarehouseCheckCampaignNames, payload);
    yield put(setWHCheckCampaignNames({
      results: results,
    }));
    yield put(WarehouseNamesLoader());
  } catch (error) {
    yield put(WarehouseNamesLoader());
    showErrorMessage(getErrorMessage(error));
  }
}

function* warehouseSaga() {
  yield takeEvery(
    GET_WAREHOUSE_CHECK_CAMPAIGN_NAMES,
    onGetWarehouseCheckCampaignNames
  );
  yield takeEvery(
    GET_WAREHOUSE_CABINET_LIMITS, onGetCabinetLimits
  );
  yield takeEvery(
    GET_WAREHOUSE_CABINET_LIMITS_TOTAL, onGetCabinetLimitsTotal
  );
}

export default warehouseSaga;
